import { render, staticRenderFns } from "./AccountDetailCard.vue?vue&type=template&id=0c48b1ac"
import script from "./AccountDetailCard.vue?vue&type=script&lang=ts"
export * from "./AccountDetailCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports